import Swiper, { Mousewheel, Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use([ Mousewheel, Navigation, Pagination]);

document.addEventListener('DOMContentLoaded',function() {
    
    const article = document.getElementsByClassName('js-articleSlider'),
          related = document.getElementsByClassName('js-relatedSlider')[0],
          stories = document.getElementsByClassName('js-storiesSlider')[0],
          team = document.getElementsByClassName('js-teamSlider')[0];
    
    const articleCarousel = function() {
        
        let swiper;
        
        for (let i = 0; i < article.length; i ++) {
            swiper = new Swiper(article[i], {
                effect: 'fade',
                navigation: {
                    nextEl: article[i].parentNode.parentNode.getElementsByClassName('js-pagination')[0].getElementsByClassName('swiper-button-next')[0],
                    prevEl: article[i].parentNode.parentNode.getElementsByClassName('js-pagination')[0].getElementsByClassName('swiper-button-prev')[0],
                },
                pagination: {
                    el: article[i].parentNode.parentNode.getElementsByClassName('js-pagination')[0].getElementsByClassName('swiper-pagination')[0],
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '">' + (index + 1) + "</span>";
                    },
                },
                speed: 500
            });
        }
    };
    
    const relatedCarousel = function() {
	    const swiper = new Swiper(related, {
    	    breakpoints: {
        	    501: {
            	    pagination: {
                	    dynamicBullets: true,
            	    },
            	    slidesPerView: 2,
        	    },
        	    1025: {
            	    pagination: {
                	    dynamicBullets: false,
            	    },
            	    slidesPerView: 3,
        	    }
    	    },
            navigation: {
                nextEl: related.parentNode.getElementsByClassName('js-pagination')[0].getElementsByClassName('swiper-button-next')[0],
                prevEl: related.parentNode.getElementsByClassName('js-pagination')[0].getElementsByClassName('swiper-button-prev')[0],
            },
            pagination: {
                el: related.parentNode.getElementsByClassName('js-pagination')[0].getElementsByClassName('swiper-pagination')[0],
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + (index + 1) + "</span>";
                },
                dynamicBullets: true,
            },
            spaceBetween: 28,
            speed: 500
        });
        
        const countSlides = function() {
            if (window.innerWidth > 1024) {
                if (related.getElementsByClassName('swiper-slide').length <= 3) {
                    related.parentNode.getElementsByClassName('js-pagination')[0].style.display = 'none';
                    swiper.allowTouchMove = false;
                }
            } else {
                related.parentNode.getElementsByClassName('js-pagination')[0].removeAttribute('style');
                swiper.allowTouchMove = true;
                swiper.pagination.update();
            }
        };
        
        countSlides();
        window.addEventListener('resize', countSlides);
    };

    const teamCarousel = function() {
	    const swiper = new Swiper(team, {
            freeMode: true,
            navigation: {
                nextEl: '.c-meet .swiper-button-next',
                prevEl: '.c-meet .swiper-button-prev',
            },
            slidesPerView: 'auto',
        });
    };

    const storiesCarousel = function() {
	    const swiper = new Swiper(stories, {
    	    breakpoints: {
        	    501: {
            	    slidesPerView: 2,
        	    },
        	    641: {
            	    slidesPerView: 3,
        	    }
    	    },
    	    centeredSlides: false,
            navigation: {
                nextEl: '.c-stories .swiper-button-next',
                prevEl: '.c-stories .swiper-button-prev',
            },
            pagination: {
                el: '.c-stories .swiper-pagination',
                clickable: true
            },
            slidesPerView: 'auto',
            spaceBetween: 10,
            speed: 800,            	    
        });
    };

    window.carousels = function() {
        
        article ? articleCarousel() : false;
        related ? relatedCarousel() : false;
        stories ? storiesCarousel() : false;
        team ? teamCarousel() : false;
        
    }

}, false)
